window.addEventListener('DOMContentLoaded', function () {

  if ($('#movie')) {
    const elemPos = $('#movie').offset().top;
    const movie_contents = $('#movie_contents');
    scrollIn(elemPos, movie_contents);
  }
});

function scrollIn(elemPos, movie_contents) {
  scrollInEvent(elemPos, movie_contents);
  $(window).on('scroll', function () {
    scrollInEvent(elemPos, movie_contents);
  });
}

function scrollInEvent(elemPos, movie_contents) {
  const header = $('#js-header').height();
  var scroll = $(window).scrollTop();
  var distance = 5;
  if ($('html').hasClass('isSP')) {
    distance = 0;
  }
  const movie_contents_pos = $('#movie_contents').offset().top;
  const movie_contents_height = $('#movie_contents').height();
  const movie_height = $('#movie').height();
  if ((scroll + header + distance) > elemPos) {
    // console.log(`scroll=${scroll} movie_contents pos=${movie_contents_pos} height=${movie_contents_height} movie_height=${movie_height}`)
    if (scroll > (movie_contents_height + movie_contents_pos - movie_height)) {
      $('#movie').addClass('fixed_end');
    } else {
      $('#movie').addClass('fixed');
      $('#movie').removeClass('fixed_end');
    }
  } else {
    $('#movie').removeClass('fixed');
  }
}
